import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import { OutboundLink } from "gatsby-plugin-google-analytics"

// bundles
import house from "../images/bundles/house.svg"
import heart from "../images/bundles/heart.svg"
import bag from "../images/bundles/bag.svg"

const Bundles = ({ header, desc, omit }) => (
  <div className="bundles">
    <div className="top">
      <div className="top__header">{header}</div>
      <div className="top__desc">{desc}</div>
    </div>
    <div className="bundle__container">
      {omit !== "experience" ? (
        <div className="bundle">
          <div className="bundle__icon">
            <img src={house} alt="Shop by Experience" />
          </div>
          <div className="bundle__header t9">Shop by Experience</div>
          <div className="bundle__desc t5">
          See products grouped together to create brighter home experiences.
          </div>
          <Link to="/experiences/" className="bundle__cta cta t7">
            Learn More
          </Link>
        </div>
      ) : null}
      {omit !== "popular" ? (
        <div className="bundle">
          <div className="bundle__icon">
            <img src={heart} alt="Popular Packages" />
          </div>
          <div className="bundle__header t9">Popular Packages</div>
          <div className="bundle__desc t5">
          Browse our best-selling combos that have worked well for other customers.
          </div>
          <Link to="/popular/" className="bundle__cta cta t7">
            Learn More
          </Link>
        </div>
      ) : null}
      {omit !== "all" ? (
        <div className="bundle">
          <div className="bundle__icon">
            <img src={bag} alt="All Products" />
          </div>
          <div className="bundle__header t9">Build Your Own</div>
          <div className="bundle__desc t5">
          Custom-build your own BrightSuite with products to match your lifestyle.
          </div>
          <Link to="/build-your-own/" className="bundle__cta cta t7">
            Learn More
          </Link>
        </div>
      ) : null}
    </div>
  </div>
)

Bundles.propTypes = {
  header: PropTypes.string,
  desc: PropTypes.string,
  omit: PropTypes.string,
}

Bundles.defaultProps = {
  header: "Additional Ways to Shop",
  desc: "Select the style that works best for you.",
  omit: "",
}

export default Bundles
